import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TaskModal from 'components/TaskModal';
import { RootState } from 'store';
import {
  setGlobalTaskModalClosedTrigger,
  setGlobalTaskModalDeletedTrigger,
  setGlobalTaskModalRemovedRequestTrigger,
  setGlobalTaskModalSavedTrigger,
  setGlobalTaskModalUpdatedSubtaskTrigger,
} from 'store/container/globalTaskModal/globalTaskModal-slice';
import useUrlSearchParams from 'utils/useUrlSearchParams';
import useRequestSource from 'utils/useRequestSource';

const GlobalTaskModal = () => {
  const search = useUrlSearchParams();

  useRequestSource('GlobalTaskModal', !!search.get('task_uuid'));

  const taskProject = useSelector((store: RootState) => store.globalTaskModal.project);

  const history = useHistory();

  const dispatch = useDispatch();

  const taskAnyProject = search.has('task_any_project');

  return (
    <TaskModal
      visible={search.get('task_uuid')}
      project={taskAnyProject ? undefined : taskProject}
      highlightCommentUuid={search.get('task_comment_uuid') ?? undefined}
      createToParentUuid={search.get('task_parent_id') ?? undefined}
      createToStatus={search.get('create_task_status') ?? undefined}
      createFromTaskUuid={search.get('task_copy_uuid') ?? undefined}
      isPersonal={search.has('task_personal')}
      onSaved={() => dispatch(setGlobalTaskModalSavedTrigger())}
      onRemoveRequest={() => dispatch(setGlobalTaskModalRemovedRequestTrigger())}
      onUpdateSubtask={() => dispatch(setGlobalTaskModalUpdatedSubtaskTrigger())}
      onDeleteTask={() => dispatch(setGlobalTaskModalDeletedTrigger())}
      onClose={() => {
        history.push(history.location.pathname);
        dispatch(setGlobalTaskModalClosedTrigger());
      }}
    />
  );
};

export default GlobalTaskModal;
